var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"loc bold_locale",class:_vm.switcherClass,on:{"click":function($event){return _vm.switchLocale()}}},[_vm._v(" "+_vm._s(_vm.otherLocale.toUpperCase())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }